import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import PricingSummaryFooter from './PricingSummaryFooter';
import { getDOMContainer } from '../utils/utility.js';
import { CaDisclaimer } from './CanadaDisclaimerContent';

export default class PricingSummaryFooterPortal extends React.Component {
	constructor(props) {
		super(props);
		this.el = document.createElement('div');
	}

	componentWillUnmount() {
		if (this.containerEl) {
			this.containerEl.removeChild(this.el);
		}
	}

	render() {
		this.containerEl = getDOMContainer(
			document,
			'.ddc-detailed-pricing-footer'
		);
		if (this.containerEl) {
			this.containerEl.appendChild(this.el);
		}

		const { dealerAddress, viewPriceDetail, summary } = this.props;

		const summaryComp = (
			<div>
				<PricingSummaryFooter
					summary={summary}
					viewPriceDetail={viewPriceDetail}
				/>
				<CaDisclaimer dealerAddress={dealerAddress} isFooter />
			</div>
		);

		// if there is a pricing footer, render in portal
		if (this.containerEl) {
			return ReactDOM.createPortal(summaryComp, this.el);
		}

		return summaryComp;
	}
}

PricingSummaryFooterPortal.propTypes = {
	summary: PropTypes.arrayOf(
		PropTypes.shape({
			_type: PropTypes.string.isRequired,
			formatted: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			value: PropTypes.number.isRequired
		})
	).isRequired,
	dealerAddress: PropTypes.shape({
		address1: PropTypes.string,
		address2: PropTypes.string,
		address3: PropTypes.string,
		city: PropTypes.string,
		state: PropTypes.string,
		postalCode: PropTypes.string,
		country: PropTypes.string
	}),
	viewPriceDetail: PropTypes.func.isRequired
};

PricingSummaryFooterPortal.defaultProps = {
	dealerAddress: {}
};



// WEBPACK FOOTER //
// ./src/components/PricingSummaryFooterPortal.jsx